module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dMOJSZ/tc-custom/9781571318060.jpg?1705766068149",
      "alt": "This image is the cover for the book Fancy Beasts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fancy Beasts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("California wildfires, the 2008 election, plastic surgery, Larry Craig, wildfires, Wal-Mart, and rampant commercialism—in "), _c('i', [_vm._v("Fancy Beasts")]), _vm._v(", Alex Lemon takes on American media culture, the obscene foil for personal legacies of violence and violation.")])]), _c('p', [_vm._v("The poems of this collection are a workout: vigorous and raw, frenetic and fearless. Yet they are also composed and controlled, pared down and sculpted, with a disarming narrative simplicity and directness. Even when dealing with toxic content—including the turning point in a life of abuse, in which the recovering victim/perpetrator puzzles through the paradigm of son-to-husband-to-father—Lemon’s point of view is always genuine and trustworthy.")]), _c('p', [_vm._v("A frank, funny, and inimitably frenetic vision of post-millennial America, "), _c('i', [_vm._v("Fancy Beasts")]), _vm._v(" is a stunning achievement from Alex Lemon.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alex Lemon\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Perseus\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0